export function firstNameFromEmail(email: string | null | undefined) {
  const name = email?.split('@')[0].split(/[._-]/)[0] ?? ''
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
}
